/**
 * Global data transition
 */

export const _hub_touchPoints = {
  start: null,
  now: null,
  last: null,
  mode: null,
  thisVector: null, // p5.Vector
  lastVector: null,
  thisStamp: null,
  lastStamp: null,
  lastMagStage: 0,
  speeds: [],
  aveSpeed: 0,
  _onTextOrAtLeastNotToClear: false,
  historyHighestMagStage: 0,
  mergedTimes: 0,
  dynamicMerges: [],
  _mapMode_initStart: null,
  _mapMode_initEnd: null,
  _mapMode_savedDistances: [],
}

export const _hub_scrolling = {
  current: false,
}

export const _hub_restore_touchPoints = () => {
  _hub_touchPoints.start = null
  _hub_touchPoints.now = null
  _hub_touchPoints.mode = null
  _hub_touchPoints.thisVector = null
  _hub_touchPoints.lastVector = null
  _hub_touchPoints.thisStamp = null
  _hub_touchPoints.lastStamp = null
  _hub_touchPoints.lastMagStage = 0
  _hub_touchPoints.speeds = []
  _hub_touchPoints.aveSpeed = 0
  _hub_touchPoints._onTextOrAtLeastNotToClear = false
  _hub_touchPoints.historyHighestMagStage = 0
  _hub_touchPoints.mergedTimes = 0
  _hub_touchPoints.dynamicMerges = []

  _hub_touchPoints._mapMode_initStart = null
  _hub_touchPoints._mapMode_initEnd = null
  _hub_touchPoints._mapMode_savedDistances = []
}

export const _hub_exp_expId = { current: null }
export const _hub_exp_speedMapping = { current: 4 }
export const _hub_exp_thisTask = {
  mode: null,
  taskType: null,
  taskId: null,
  originalText: null,
  text: null,
  targetText: null,
}
